import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement("g", { clipPath: "url(#transactions_svg__clip0_1730_103062)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M1.145 19.93h5.714a5.714 5.714 0 015.714 5.715M5.716 25.645h11.429a4.572 4.572 0 014.571 4.571 1.143 1.143 0 01-1.143 1.143H1.145",
      stroke: "#2d6ded",
      strokeWidth: 2.57,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.287 19.93c5.006 0 8.572-1.76 8.572-5.6 0-4.228-2.149-7.063-6.423-9.143l1.691-2.171a.938.938 0 00-.8-1.371h-6.08a.937.937 0 00-.8 1.348L20.14 5.28c-4.275 2.08-6.423 4.823-6.423 9.051 0 3.84 3.566 5.6 8.571 5.6z",
      stroke: "#2d6ded",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.457 9c.305 0 .607.05.894.15a.75.75 0 10.492-1.417 4.227 4.227 0 00-1.44-.232 4.853 4.853 0 00-4.34 3.197H17.75a.75.75 0 000 1.5h1.026a4.912 4.912 0 000 .319c-.003.105-.003.21 0 .314H17.75a.75.75 0 000 1.5h1.311a4.853 4.853 0 004.375 3.202 4.307 4.307 0 001.722-.353.75.75 0 00-.595-1.377c-.35.151-.726.23-1.107.23a3.352 3.352 0 01-2.75-1.702h1.31a.75.75 0 000-1.5h-1.74a3.387 3.387 0 010-.284v-.06a3.377 3.377 0 010-.29h1.74a.75.75 0 000-1.5h-1.308A3.353 3.353 0 0123.458 9z",
      fill: "#2d6ded"
    }
  )),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "transactions_svg__clip0_1730_103062" }, /* @__PURE__ */ e.createElement("path", { fill: "#fff", transform: "translate(0 .5)", d: "M0 0h32v32H0z" })))
), n = a;
export {
  n as default
};
